import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { Button, Col, message, Radio, Row, Space, Switch } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import {
  selectConfigActionEvent,
  selectPaymentConfigEvent,
  selectPaymentConfigList,
} from 'Store/pos/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { AppInput, AppSelect } from 'Components/form'
import { AppTutorial, StatusTag, ThaiQRPayment } from 'Components/utilities'
import { ConfirmDailog, LoadingView } from 'Components/modal'
import { GetPaymentConfigReq, PaymentConfig, PaymentConfigReq } from 'Store/pos/types'
import { getPaymentConfigListAPI, setPaymentConfigAPI } from 'Store/pos/api'
import { clearEventAction } from 'Store/pos/actions'
import { MyTheme } from 'Components/common/Theme'
import { formValidation, isFormError, isFormRequired, mergeArray } from 'helpers/format'
import { cloneDeep } from 'lodash'
import { DefaultStatus, menuBankAccount, MerchantType } from 'helpers/constanst'
import { PrimaryButton } from 'Components/button'
import { TutorialPaymentConfig } from 'helpers/tutorials'

type Props = {} & ReduxProps

const PaymentConfigPage: React.FunctionComponent<Props> = props => {
  const { currentUser, actionEvent, event, configData } = props
  const initForm = {
    payment_type: 'individual',
  } as PaymentConfig
  const dispatch = useDispatch()
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [qrStatus, setQrStatus] = useState(false)
  const [creditStatus, setCreditStatus] = useState(false)
  const [transferStatus, setTransferStatus] = useState(false)
  // tutorial
  const [showTutorial, setShowTutorial] = useState(false as boolean)
  const steps = TutorialPaymentConfig.setting.steps
  const enableTutorial = TutorialPaymentConfig.setting.enable
  const qrIndividualRequired = ['personal_id', 'account_name'] as string[]
  const [confirmSaveDialog, setConfirmSaveDialog] = useState(false)
  const [oldPaymentType, setOldPaymentType] = useState('')
  const merchantId = currentUser?.activeMerchant?.id || 0
  const qrCorporateRequired = [
    'account_name',
    'account_number',
    'tax_id',
    'bank_name',
    'bill_payment_id',
  ] as string[]
  let requireFeild = [] as string[]
  if (qrStatus && formData.payment_type === MerchantType.INDIVIDUAL) {
    requireFeild = mergeArray([requireFeild, qrIndividualRequired])
  }
  if (qrStatus && formData.payment_type === MerchantType.COPORATE) {
    requireFeild = mergeArray([requireFeild, qrCorporateRequired])
  }
  const [formError, setFormError] = useState([] as string[])

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  useEffect(() => {
    onGetConfig()
  }, [])

  const onUpdateData = (val: any, key: string) => {
    console.log('key', key, val.length)
    if (
      (key === 'personal_id' && val.length > 13) ||
      (key === 'tax_id' && val.length > 13) ||
      (key === 'account_number' && val.length > 10) ||
      (key === 'bill_payment_id' && val.length > 15)
    ) {
      return
    }
    setFormData({
      ...formData,
      [key]: val,
    })
  }

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  useEffect(() => {
    console.log('configData', configData)
    if (configData) {
      configData &&
        configData.forEach(item => {
          if (item.payment_type === 'coporate' || item.payment_type === 'individual') {
            if (item.status === DefaultStatus.ACTIVE) {
              setOldPaymentType(item.payment_type)
              setQrStatus(true)
              setFormData({ ...item })
            }
          }
          if (item.payment_type === 'credit_term') {
            setCreditStatus(item.status === DefaultStatus.ACTIVE)
          }
          if (item.payment_type === 'transfer_pos') {
            setTransferStatus(item.status === DefaultStatus.ACTIVE)
          }
        })
    }
  }, [configData])

  useEffect(() => {
    setFormData(cloneDeep({ ...initForm }))
    setFormError([])
    setQrStatus(false)
    setTransferStatus(false)
    setCreditStatus(false)
    setOldPaymentType('')
  }, [])

  const onGetConfig = () => {
    const req: GetPaymentConfigReq = {}
    dispatch(getPaymentConfigListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const formatReq = () => {
    const data = [] as PaymentConfig[]
    if (formData.id || qrStatus) {
      data.push({
        ...formData,
        merchant_id: merchantId,
        status: qrStatus ? DefaultStatus.ACTIVE : DefaultStatus.INACTIVE,
      })
    }
    console.log('formData.payment_type !== oldPaymentTyp', formData.payment_type, oldPaymentType)
    if (formData.payment_type !== oldPaymentType) {
      const oldPaymentData = configData?.find(item => item.payment_type === oldPaymentType)
      if (oldPaymentData) {
        data.push({
          ...oldPaymentData,
          merchant_id: merchantId,
          status: DefaultStatus.INACTIVE,
        })
      }
    }

    data.push({
      merchant_id: merchantId,
      payment_type: 'credit_term',
      status: creditStatus ? DefaultStatus.ACTIVE : DefaultStatus.INACTIVE,
      id: configData?.find(item => item.payment_type === 'credit_term')?.id || 0,
    })
    data.push({
      merchant_id: merchantId,
      payment_type: 'transfer_pos',
      status: transferStatus ? DefaultStatus.ACTIVE : DefaultStatus.INACTIVE,
      id: configData?.find(item => item.payment_type === 'transfer_pos')?.id || 0,
    })
    return data
  }

  const onUpdateConfig = () => {
    const req: PaymentConfigReq = {
      data: formatReq(),
    }
    console.log('req', req)
    dispatch(setPaymentConfigAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    if (formData.payment_type === 'individual') {
      if (formData.personal_id && formData.personal_id.length !== 10 && formData.personal_id.length !== 13) {
        error.push('personal_id_format')
      }
    }

    if (formData.payment_type === 'coporate') {
      if (formData.tax_id && formData.tax_id.length !== 13) {
        error.push('tax_id_format')
      }
      if (formData.account_number && formData.account_number.length !== 10) {
        error.push('account_number_format')
      }
      if (formData.bill_payment_id && formData.bill_payment_id.length !== 15) {
        error.push('bill_payment_id_format')
      }
    }
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onUpdateSuccess = (): void => {
    clearEvent()
    onCloseConfirmDailog()
    onGetConfig()
  }

  const onClickSave = () => {
    if (!validateForm()) {
      message.error('กรุณาระบุข้อมูลให้ถูกต้อง')
      return
    }
    onOpenConfirmDailog()
  }

  const onOpenConfirmDailog = () => {
    setConfirmSaveDialog(true)
  }

  const onCloseConfirmDailog = () => {
    setConfirmSaveDialog(false)
  }

  // const ConfirmActivateModal = (
  //   <ConfirmDailog
  //     title={'คำเตือนการเปลี่ยนแปลงการใช้งาน'}
  //     description={
  //       'เมื่อคุณเปิดใช้งานปุ่มบังคับเปิดรอบการขาย บนเครื่องเทอมินอลจะบังคับให้ทำการเปิดรอบการขายเพื่อทำการบันทึกการขายสินค้าเป็นรอบ/กะ'
  //     }
  //     isShow={showConfirm}
  //     handleOk={() => onUpdateConfig(!isEnableCashDrawer)}
  //     handleCancel={() => setShowConfirm(false)}
  //     confirmBtnTxt="ยืนยันการเปลี่ยนแปลง"
  //   />
  // )

  const onStartTutorial = () => {
    setShowTutorial(true)
  }
  const onEndTutorial = () => {
    setShowTutorial(false)
  }

  const QrCodePreview = (
    <Row gutter={[8, 8]} justify="center">
      <Col md={24} xs={24}>
        <Title>
          ตัวอย่าง QR Payment
          <Remark>โปรดลองใช้แอปพลิเคชันธนาคารสแกน QR Payment เพื่อตรวจสอบความถูกต้อง ก่อนบันทึกข้อมูล</Remark>
        </Title>
      </Col>
      <Col md={24} xs={24}>
        <QrWrapper>
          <ThaiQRPayment {...formData} width={200} merchantName={currentUser?.activeMerchant?.name || ''} />
        </QrWrapper>
      </Col>
    </Row>
  )

  const IndividualForm = (
    <>
      <Col md={12} xs={24}>
        <AppInput
          name="personal_id"
          label="ระบุหมายเลขพร้อมเพย์"
          placeHolder="เบอร์โทรศัพท์ หรือหมายเลขบัตรประชาชน"
          isRequired={isRequired('personal_id')}
          isError={isError('personal_id') || isError('personal_id_format')}
          errorMsg={
            isError('personal_id_format')
              ? 'รูปแบบหมายเลขพร้อมเพย์ให้ถูกต้อง (10 หรือ 13 หลัก)'
              : 'หมายเลขพร้อมเพย์'
          }
          value={formData.personal_id}
          onChange={onUpdateData}
          //type="number"
        />
      </Col>
      <Col md={12} xs={24}>
        <AppInput
          name="account_name"
          label="ชื่อบัญชี"
          isRequired={isRequired('account_name')}
          isError={isError('account_name')}
          value={formData.account_name}
          onChange={onUpdateData}
        />
      </Col>
      <Col md={24} xs={24}>
        {QrCodePreview}
      </Col>
    </>
  )

  const CorporateForm = (
    <>
      <Col md={12} xs={24}>
        <AppInput
          name="tax_id"
          label="เลขผู้เสียภาษี"
          isRequired={isRequired('tax_id')}
          isError={isError('tax_id') || isError('tax_id_format')}
          errorMsg={isError('tax_id_format') ? 'รูปแบบเลขผู้เสียภาษีให้ถูกต้อง (13 หลัก)' : 'เลขผู้เสียภาษี'}
          value={formData.tax_id}
          onChange={onUpdateData}
          //type="number"
        />
      </Col>
      <Col md={12} xs={24}>
        <AppInput
          name="account_number"
          label="หมายเลขบัญชีบริษัท"
          isRequired={isRequired('account_number')}
          isError={isError('account_number') || isError('account_number_format')}
          errorMsg={
            isError('account_number_format')
              ? 'รูปแบบหมายเลขบัญชีบริษัทให้ถูกต้อง (10 หลัก)'
              : 'หมายเลขบัญชีบริษัท'
          }
          value={formData.account_number}
          onChange={onUpdateData}
          //type="number"
        />
      </Col>
      <Col md={12} xs={24}>
        <AppInput
          name="account_name"
          label="ชื่อบัญชี"
          isRequired={isRequired('account_name')}
          isError={isError('account_name')}
          value={formData.account_name}
          onChange={onUpdateData}
        />
      </Col>
      <Col md={12} xs={24}>
        <AppSelect
          name="bank_name"
          label="ธนาคาร"
          isRequired={isRequired('bank_name')}
          isError={isError('bank_name')}
          value={formData.bank_name}
          onChange={onUpdateData}
          menu={menuBankAccount}
        />
      </Col>
      <Col md={24} xs={24}>
        <Row gutter={[8, 8]}>
          <Col md={24} xs={24}>
            <Title>กรอกข้อมูลที่ได้จากการสมัคร QR Payment จากธนาคาร</Title>
          </Col>
          <Col md={12} xs={24}>
            <AppInput
              name="bill_payment_id"
              placeHolder="ระบุ Biller ID 15 หลัก"
              label="Biller ID"
              isRequired={isRequired('bill_payment_id')}
              isError={isError('bill_payment_id') || isError('bill_payment_id_format')}
              errorMsg={
                isError('bill_payment_id_format') ? 'รูปแบบ Biller ID ให้ถูกต้อง (15 หลัก)' : 'Biller ID'
              }
              value={formData.bill_payment_id}
              onChange={onUpdateData}
              //type="number"
            />
          </Col>
          <Col md={12} xs={24}>
            <AppInput
              name="ref_1"
              placeHolder="ระบุเลขอ้างอิง 1 (ถ้ามี)"
              label="หมายเลขอ้างอิง 1 (Ref 1)"
              isRequired={false}
              isError={isError('ref_1')}
              value={formData.ref_1}
              onChange={onUpdateData}
              //type="number"
            />
          </Col>
          <Col md={12} xs={24}>
            <AppInput
              name="ref_2"
              placeHolder="ระบุเลขอ้างอิง 2 (ถ้ามี)"
              label="หมายเลขอ้างอิง 2 (Ref 2)"
              isRequired={false}
              isError={isError('ref_2')}
              value={formData.ref_2}
              onChange={onUpdateData}
              //type="number"
            />
          </Col>
        </Row>
      </Col>
      <Col md={24} xs={24}>
        {QrCodePreview}
      </Col>
    </>
  )

  const renderQrCode = () => {
    const isActive = qrStatus
    const isIndividual = formData.payment_type === MerchantType.INDIVIDUAL
    return (
      <Row justify="start">
        <Col md={24} xs={24} className="ttr-qr">
          <SwitchStyled>
            <Switch
              checked={isActive}
              onChange={(val: boolean) => {
                setQrStatus(val)
              }}
            />
            &nbsp;
            <Space align="baseline">
              <Title>ชำระเงินแบบ QR Payment</Title>
              <StatusTag isPass={isActive} text={isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} />
            </Space>
          </SwitchStyled>
        </Col>
        {isActive && (
          <Col md={23} xs={24} offset={1}>
            <BoxWrapper>
              <Row gutter={[8, 8]}>
                {/* <Col md={24} xs={24}>
                <Title>ข้อมูลสำหรับสร้าง QR Payment</Title>
              </Col> */}
                <Col md={24} xs={24}>
                  <Space align="baseline" direction="horizontal" size="large">
                    ประเภทร้านค้า
                    <Radio.Group
                      onChange={e => onUpdateData(e.target.value, 'payment_type')}
                      value={formData.payment_type}
                    >
                      <Radio value={MerchantType.INDIVIDUAL}>บุคคลธรรมดา</Radio>
                      <Radio value={MerchantType.COPORATE}>นิติบุคคล</Radio>
                    </Radio.Group>
                  </Space>
                </Col>
                <Col md={24} xs={24}></Col>
                {isIndividual && IndividualForm}
                {!isIndividual && CorporateForm}
              </Row>
            </BoxWrapper>
          </Col>
        )}
      </Row>
    )
  }

  const renderCredit = () => {
    const isActive = creditStatus
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch
              checked={isActive}
              onChange={(val: boolean) => {
                setCreditStatus(val)
              }}
            />
            &nbsp;
            <Space align="baseline">
              <Title>ชำระเงินแบบเครดิตเทอม (Credit Term)</Title>
              <StatusTag isPass={isActive} text={isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} />
            </Space>
          </SwitchStyled>
        </Col>
        {/* {isActive && (
          <Col md={23} xs={24} offset={1}>
            <Row gutter={[8, 8]}>
              <Col md={12} xs={24}>
                <AppInput
                  name="fee"
                  label="ค่าธรรมเนียม"
                  isRequired={isRequired('fee')}
                  isError={isError('fee')}
                  value={formData.fee}
                  onChange={onUpdateData}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppSelect
                  name="fee_type"
                  label="ประเภทค่าธรรมเนียม"
                  isRequired={isRequired('fee_type')}
                  isError={isError('fee_type')}
                  value={formData.fee_type}
                  onChange={onUpdateData}
                  menu={menuFeeType}
                />
              </Col>
            </Row>
          </Col>
        )} */}
      </Row>
    )
  }

  const renderTransfer = () => {
    const isActive = transferStatus
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch
              checked={isActive}
              onChange={(val: boolean) => {
                setTransferStatus(val)
              }}
            />
            &nbsp;
            <Space align="baseline">
              <Title>ชำระเงินแบบโอนเงินผ่านบัญชีธนาคาร</Title>
              <StatusTag isPass={isActive} text={isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} />
            </Space>
          </SwitchStyled>
        </Col>
        {/* {isActive && (
          <Col md={23} xs={24} offset={1}>
            <Row gutter={[8, 8]}>
              <Col md={12} xs={24}>
                <AppInput
                  name="fee"
                  label="ค่าธรรมเนียม"
                  isRequired={isRequired('fee')}
                  isError={isError('fee')}
                  value={formData.fee}
                  onChange={onUpdateData}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppSelect
                  name="fee_type"
                  label="ประเภทค่าธรรมเนียม"
                  isRequired={isRequired('fee_type')}
                  isError={isError('fee_type')}
                  value={formData.fee_type}
                  onChange={onUpdateData}
                  menu={menuFeeType}
                />
              </Col>
            </Row>
          </Col>
        )} */}
      </Row>
    )
  }

  const ConfirmSaveDailog = (
    <ConfirmDailog
      title="ยืนยันการบันทึกข้อมูล"
      description="คุณแน่ใจที่จะบันทึกข้อมูลหรือไม่?"
      confirmBtnTxt="บันทึก"
      isShow={confirmSaveDialog}
      handleOk={onUpdateConfig}
      handleCancel={onCloseConfirmDailog}
    />
  )

  return (
    <HomePageLayout
      selected="pos-payment-config"
      title={'การตั้งค่าช่องทางการรับชำระเงิน'}
      // bgColor={'#fff'}
      isShowTutorial={showTutorial}
      showTutorial={enableTutorial}
      onClickStart={onStartTutorial}
    >
      <Row>
        <Col span={24} className="ttr-transfer">
          {renderTransfer()}
        </Col>
        <Col span={24}>{renderQrCode()}</Col>
        <Col span={24} className="ttr-credit-term">
          {renderCredit()}
        </Col>
      </Row>
      <Row justify="center">
        <Col>
          <Space size="large">
            <MyButton type="primary" onClick={onClickSave} className="ttr-save">
              บันทึกข้อมูล
            </MyButton>
            <PrimaryButton btnType="Cancel" text="ยกเลิก" onClick={onGetConfig} className="ttr-cancel" />
          </Space>
        </Col>
      </Row>
      <EventModal
        event={[actionEvent]}
        enable={true}
        successCalback={onUpdateSuccess}
        errorCalback={clearEvent}
      />
      <LoadingView isShow={event.IsLoading} />
      {ConfirmSaveDailog}
      {/* {ConfirmActivateModal} */}
      {/* {LoadingModal}*/}
      {enableTutorial && (
        <AppTutorial onCloaseTutorial={onEndTutorial} showTutorial={showTutorial} steps={steps} />
      )}
    </HomePageLayout>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    actionEvent: selectConfigActionEvent(state),
    event: selectPaymentConfigEvent(state),
    configData: selectPaymentConfigList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-bottom: 10px;
`

const Remark = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const SwitchStyled = styled.div`
  margin: 10px 0;
`

const MyButton = styled(Button)`
  height: 45px;
  border-radius: 5px;
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 20px 20px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const QrWrapper = styled.div`
  border-radius: 10px;
  padding: 20px 20px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  text-align: center;
`

export default connect(mapStateToProps)(PaymentConfigPage)
